export enum PaymentPreferencesAnalyticsMessages {
  capability = 'payments',
  pageLoadedEvent = 'page loaded',
  addBankAccountEvent = 'add bank account',
  buttonClickEvent = 'button click',
  setupAutopayOption = 'Setup Autopay',
  pageName = 'us foods:r4:payment preferences',
  manualDeductType = 'manual deduct',
  autoDeductType = 'auto deduct', //TBD text
  existingBankAccount = 'Existing Account',
  newBankAccount = 'New Account',
}
